import { ReactNode, useMemo } from "react";
import { AddableCourse, CourseLite, CourseSummary } from "../../types/course.response";
import { Requirement, Select } from "../../types/requirement.response";
import { getAllCourseOptionsForRequirement } from "../../utils/requirementResponseUtils";
import HeaderAddCourse from "./HeaderAddCourse";
import HeaderCourseSetSlots from "./HeaderCourseSetSlots";

interface HeaderGroupSlotsProps {
    rootNode: Select;
    requirement: Requirement;
    requirementId: string;
    coursesMap: Record<string, CourseSummary>;
    onAdd: (course: AddableCourse, nodeId: string | null) => void | Promise<void>;
    onDelete: (course: CourseLite) => void | Promise<void>;
    removeDropZone?: ReactNode;
    isBroad?: boolean;
}

export default function HeaderGroupSlots({ rootNode, requirement, requirementId, coursesMap, onAdd, onDelete, removeDropZone, isBroad }: HeaderGroupSlotsProps) {
    const isFulfilled = rootNode.summary.isFulfilled;

    const allCourses = useMemo(
        () => getAllCourseOptionsForRequirement(requirement, coursesMap),
        [requirement, coursesMap]
    );

    return (
        <div className="flex flex-wrap items-center gap-1.5 mt-3">
            {rootNode.children.map((child) => {
                if (child.type !== "COURSE_SET") return null;
                return (
                    <HeaderCourseSetSlots
                        key={child.id}
                        courseSet={child}
                        coursesMap={coursesMap}
                        requirementId={requirementId}
                        onAdd={(course) => onAdd(course, child.id)}
                        onDelete={onDelete}
                        isBroad={isBroad}
                    />
                );
            })}
            {isFulfilled && (
                <HeaderAddCourse
                    allCourses={allCourses}
                    onAdd={(course) => onAdd(course, null)}
                    nodeId={null}
                    dropId={`header-group-slot-${requirement.info.id}-extra`}
                    isBroad={isBroad}
                />
            )}
            {removeDropZone}
        </div>
    );
}
